import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Avatar, Badge, IconButton} from '@material-ui/core';
import api from 'controllers/raymanAPI';
import Singletons from 'controllers/Singletons';
import { CameraAlt } from '@material-ui/icons';
import {UsersCtx} from 'components/dataProviders/users';
import HiddenFileInput from 'components/files/HiddenFileInput';
const useStyles = makeStyles((theme) => ({
    root: {
      padding: 25
    },
    infoPair: {
      marginTop: 25
    },
    infoTitle: {
      fontSize: '18px',
      FontWeight: 800,
      color: theme.palette.text.secondary
    },
    infoField: {
      fontSize: '15px',
      FontWeight: 600,
      color: theme.palette.text.secondary,
      whiteSpace: "pre-line"
    },
    avatar: {
        width: 48,
        height: 48
    },
    pictureButton: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.secondary.main,
        width: 10,
        height: 10,
        fontSize: "15px",
        '&:hover':
        {
            backgroundColor: theme.palette.secondary.main,
        },
        '& .MuiSvgIcon-root': {
            fontSize: "inherit"
        }
    }
  }), {name: "UserInfo"});

export default function UserInfo({user})
{
    const classes = useStyles();
    const ctx = React.useContext(UsersCtx);
    const input = React.useRef();
    function onUpload(){
        ctx.funcs.setAvatar(user.userID, true);
    }
    const initials = user.name.substring(0,1)+user.surname1.substring(0,1);
    const editable = user.userID === Singletons.currentUser.userID;
    const avatar = <Avatar alt={user.name + " "+ user.surname1} src={ user.avatar ? user.avatarSrc : null} className={classes.avatar}>{!user.avatar && initials}</Avatar>;
    const badge = <Badge
        overlap="circle"
        anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
        }}
        badgeContent={<IconButton className={classes.pictureButton} color="secondary" onClick={()=>input.current.click()}><CameraAlt /></IconButton>}
    > {avatar} </Badge>;

    return <div className={classes.root}>
        <HiddenFileInput ref={input} apiFileEndpoint={api.users.avatar} apiRequestParams={[user.userID]} onUpload={onUpload} inputAccept="*.png, *.jpg" />
        {editable ? badge : avatar}
    <div className={classes.infoPair}>
      <div className={classes.infoHeader}>Nombre</div>
      <div className={classes.infoField}>{user.name}</div>
    </div><div className={classes.infoPair}>
      <div className={classes.infoHeader}>Apellidos</div>
      <div className={classes.infoField}>{user.surname1+" "+user.surname2}</div>
    </div><div className={classes.infoPair}>
      <div className={classes.infoHeader}>Email</div>
      <div className={classes.infoField}>{user.email}</div>
    </div><div className={classes.infoPair}>
      <div className={classes.infoHeader}>{user.profiles.length > 1 ? "Perfiles" : "Perfil"}</div>
      <div className={classes.infoField}>{user.profiles.length === 0 ? "Sin perfil" : 
        user.profiles.map((profile) => {
          switch(profile)
          {
              case "administrators": return "Administrador";
              case "experts": return "Experto";
              case "operators": return "Operario";
              default: return "";
          }
        }).join(", ")
      }</div>
      { user.info && <>
        <div className={classes.infoPair}>
          <div className={classes.infoHeader}>Información Adicional</div>
          <div className={classes.infoField}>{user.info}</div>
        </div>
      </>}
    </div>
  </div>
}